export const environment = {
  production: true,
  apiUrl: 'https://cmgsvcgdocsbulkexportapiappprod01.azurewebsites.net',
  msalConfig: {
    auth: {
      clientId: '1ff4b2d6-c664-4b8b-83ce-9fd3890e7f75',
      authority:
        'https://login.microsoftonline.com/57d88166-f247-4dee-a6f9-e6359f96ff2c',
    },
    apiScope: 'api://6233984d-ad57-4c77-86ea-53bf7d797b7d/adminapiscope',
    graphScope: 'user.read',
    graphUri: 'https://graph.microsoft.com/v1.0/',
  },
  enablePhase2: true,
  defaultServiceProviderGuid: '6f85a78e-f7c6-4fb4-9789-52fc16d71e3f',
};
